// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { DNode, MiddlewareMap, MiddlewareResultFactory, WidgetProperties } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { RegistryHandler } from '@dojo/framework/core/RegistryHandler';

import { Store } from '@dojo/framework/stores/Store';
import { Registry } from '@dojo/framework/core/Registry';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { createStoreMiddleware, StoreApi } from '@holmescorp/middleware';

import { SiteMeta, UserMeta } from './interfaces';

export const lccstore = new Store<SiteMeta>();
export const userstore = new Store<UserMeta>();
export const registry = new Registry();

registry.defineInjector('lcc-state', () => () => lccstore);
registry.defineInjector('user-state', () => () => userstore);

export const lccstate = createStoreMiddleware('lcc-state');
export const userstate = createStoreMiddleware('user-state');
